import axios from "axios";

export default {
    // apiUrl: 'http://api.elc.bizbrain.in/api/',
    successToast: {
        theme: "primary",
        position: "top-right",
        duration: 3000,
        className: 'success-toast'
    },
    apiUrl: process.env.API_KEY,
    taluka:['Bayad','Bhiloda','Dhansura','Malpur','Meghraj','Modasa'],
    rolePrefix: [
        {id: 0, value: 'Nodal Officer'},
        {id: 1, value: 'AERO Officer'},
        {id: 2, value: 'ERO Officer'},
        {id: 3, value: 'DY DEO Officer'},
        {id: 4, value: 'DEO Officer'},
        {id: 5, value: 'Staff'}
    ],
    rolePrefix_const: {
        0: "Nodal Officer",
        1: "AERO Officer",
        2: "ERO Officer",
        3: "DY DEO Officer",
        4: "DEO Officer",
        5: "Staff",
    },
    elc_type_const: {
        1: "Future Voter",
        2: "New Voter",
        3: "Chunav Pathshala",
        4: "Voter Awareness Forum",
    },
    elc_type: [
        {id: 1, value: "Future Voter"},
        {id: 2, value: "New Voter"},
        {id: 3, value: "Chunav Pathshala"},
        {id: 4, value: "Voter Awareness Forum"},
    ],
    elc_type_constant: {
        'Future Vote':1,
        'New Voter':2 ,
        'Chunav Pathshala':3 ,
        'Voter Awareness Forum':4
    },
    kbType: [
        {id: 4, name: "Audio"},
        {id: 5, name: "FAQs"},
        {id: 3, name: "File"},
        {id: 1, name: "Image"},
        {id: 6, name: "Text"},
        {id: 7, name: "URL"},
        {id: 2, name: "Video"},
        {id: 21, name: "YouTube Video"},
    ],
    kbType_const: {
        1: "Image",
        2: "Video",
        3: "File",
        4: "Audio",
        5: "FAQs",
        6: "Text",
        7: "URL",
        21: "YouTube Video",
    },
    kbType_backend_const: {
        10: "FAQs",
        // 10: "Text",
        12: "URL",
    },
    namePrefix: ['Mr', 'Mrs', 'Miss','ડો','શ્રી','શ્રીમતી'],
    // namePrefix: ['Mr', 'Mrs', 'Miss', 'Shri', 'Smt','શ્રી','શ્રીમતી'],
}



// WEBPACK FOOTER //
// ./src/components/Common/Constants.js